import { render, staticRenderFns } from "./modalInformacionCedis.vue?vue&type=template&id=2cb3c9b4&scoped=true&"
import script from "./modalInformacionCedis.vue?vue&type=script&lang=js&"
export * from "./modalInformacionCedis.vue?vue&type=script&lang=js&"
import style0 from "./modalInformacionCedis.vue?vue&type=style&index=0&id=2cb3c9b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb3c9b4",
  null
  
)

export default component.exports